import { render } from "./Claim3_Main.vue?vue&type=template&id=7f80434a&scoped=true"
import script from "./Claim3_Main.vue?vue&type=script&lang=js"
export * from "./Claim3_Main.vue?vue&type=script&lang=js"

import "./Claim3_Main.vue?vue&type=style&index=0&id=7f80434a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f80434a"

export default script